class CollectionFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.filterData = [];
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.productGridId = "CollectionProductGrid";
    this.filterFormsId = "CollectionFiltersForm";
    this.searchTemplate = document.querySelector("body.template-search");
    this.collectionTemplate = document.querySelector("body.template-collection");
    this.sections = this.getSections();
    this.addDrawerAttributes = this.addDrawerAttributes.bind(this);

    this.debouncedOnSubmit = this.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));

    const openBtn = document.querySelector("[data-drawer-open-btn]");
    const closeBtn = document.querySelector("[data-drawer-close-btn]");
    const overlay = document.querySelector("[data-filtering-drawer-overlay]");

    if (openBtn) openBtn.addEventListener("click", this.handleDrawerOpen.bind(this));
    if (closeBtn) closeBtn.addEventListener("click", this.handleDrawerClose.bind(this));
    if (overlay) overlay.addEventListener("click", this.handleDrawerClose.bind(this));

    window.addEventListener("resize", this.addDrawerAttributes);
    window.addEventListener("popstate", this.onHistoryChange.bind(this));

    this.addDrawerAttributes();
    this.bindActiveFacetButtonEvents();
    this.onDropDownBlur();

    this.initPriceSliderLater();
  }

  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  initPriceSliderLater() {
    setTimeout(() => {
      if (typeof window.initPriceSlider === "function") {
        window.initPriceSlider();
      }
    }, 100);
  }

  onDropDownBlur() {
    document.querySelectorAll("details").forEach((detail) => {
      document.addEventListener("click", function (event) {
        if (!detail.contains(event.target)) {
          detail.removeAttribute("open");
        }
      });
    });
  }

  addDrawerAttributes() {
    const form = document.querySelector("collection-filtering-form");
    if (!form) return;

    form.removeAttribute("role");
    form.removeAttribute("aria-modal");

    if (window.innerWidth < 991) {
      form.setAttribute("role", "dialog");
      form.setAttribute("aria-modal", "true");
    }
  }

  handleDrawerOpen(event) {
    event.target.setAttribute("tabIndex", "-1");
    document.body.classList.add("js-drawer-open-filter", "js-drawer-open");
    this.trapFocus("main-collection-filters", true);
  }

  handleDrawerClose() {
    const openBtn = document.querySelector("[data-drawer-open-btn]");
    document.body.classList.remove("js-drawer-open-filter", "js-drawer-open");

    if (openBtn) {
      openBtn.setAttribute("tabIndex", "0");
      openBtn.focus();
    }
  }

  trapFocus(id) {
    const wrapper = document.getElementById(id);
    if (!wrapper) return;

    const focusable = document.querySelectorAll(
      `#${id} input:not([type=hidden]), #${id} button:not([tabindex="-1"]), #${id} a:not([tabindex="-1"]), #${id} textarea`
    );

    const groups = document.querySelectorAll(".facets__disclosure, .collection-filters__sort");
    const first = focusable[0];

    wrapper.addEventListener("keydown", function (event) {
      const lastGroup = groups[groups.length - 1];
      const last = !lastGroup.hasAttribute("open") ? lastGroup : focusable[focusable.length - 1];

      if (event.code === "Tab" && !event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }

      if (event.code === "Tab" && event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (this.collectionTemplate) {
      const formData = new FormData(event.target.closest("form"));
      const searchParams = new URLSearchParams(formData).toString();
      this.renderPage(searchParams, event);
      return;
    }

    if (this.searchTemplate) {
      const currentParams = new URLSearchParams(window.location.search);
      const pageTypeInput = document.querySelector("#page-type-input");
      const pageTypes = Array.from((pageTypeInput?.value || "").split(","));
      const searchTypeInput = document.querySelector('.search--header input[name="type"]');

      if (pageTypeInput && pageTypeInput.value === "" && searchTypeInput) {
        pageTypeInput.value = searchTypeInput.value;
      }

      const formData = new FormData(event.target.closest("form"));
      formData.append("q", currentParams.get("q"));

      if (
        (pageTypes.includes("article") && !pageTypes.includes("product")) ||
        (pageTypes.includes("page") && !pageTypes.includes("product"))
      ) {
        document.querySelectorAll(`#${this.filterFormsId} input:not(#page-type-input)`).forEach((input) => {
          input.setAttribute("disabled", "disabled");
        });

        document.querySelectorAll(`#${this.filterFormsId} label:not(.collection-filters__label)`).forEach((label) => {
          label.classList.add("facet-checkbox--disabled");
        });
      }

      const searchParams = new URLSearchParams(formData).toString();
      this.renderPage(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    event.currentTarget.setAttribute("loading", "true");
    this.toggleActiveFacets();
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || "";
    this.renderPage(searchParams, null, false);
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((button) => {
      button.classList.toggle("disabled", disable);
    });
  }

  renderPage(searchParams, event, updateURL = true) {
    const grid = document.querySelector(`#${this.productGridId} > div`);
    if (grid) grid.classList.add("loading");

    this.sections.forEach((section) => {
      if (this.collectionTemplate) {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const cached = (item) => item.url === url;

        this.filterData.some(cached)
          ? this.renderSectionFromCache(cached, section, event)
          : this.renderSectionFromFetch(url, section, event);
      }

      if (this.searchTemplate) {
        const url = `${window.location.pathname}?${searchParams}`;
        const cached = (item) => item.url === url;

        this.filterData.some(cached)
          ? this.renderSectionFromCache(cached, section, event)
          : this.renderSectionFromFetch(url, section, event);
      }
    });

    if (updateURL) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, section, event) {
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        this.filterData = [...this.filterData, { html, url }];

        if (section.id === this.productGridId) {
          this.renderProductGrid(html);
        }

        if (section.id === this.filterFormsId) {
          this.renderFilters(html, event);
        }
      });
  }

  renderSectionFromCache(cached, section, event) {
    const html = this.filterData.find(cached).html;

    if (section.id === this.productGridId) {
      this.renderProductGrid(html);
    }

    if (section.id === this.filterFormsId) {
      this.renderFilters(html, event);
    }
  }

  renderProductGrid(html) {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const newGrid = parsed.getElementById(this.productGridId);
    const currentGrid = document.getElementById(this.productGridId);

    if (newGrid && currentGrid) {
      currentGrid.innerHTML = newGrid.innerHTML;
    }

    document.dispatchEvent(new CustomEvent("paginate"));
  }

  renderFilters(html, event) {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const newFilters = parsed.querySelectorAll(`#${this.filterFormsId} .js-filter`);

    const currentFilterIndex = event?.target?.closest(".js-filter")?.dataset.index;

    const filtersToReplace = Array.from(newFilters).filter((filter) => {
      return filter.dataset.index !== currentFilterIndex;
    });

    const currentOpenedFilter = Array.from(newFilters).find((filter) => {
      return filter.dataset.index === currentFilterIndex;
    });

    filtersToReplace.forEach((newFilter) => {
      const currentFilter = document.querySelector(`.js-filter[data-index="${newFilter.dataset.index}"]`);
      if (currentFilter) {
        currentFilter.innerHTML = newFilter.innerHTML;
      }
    });

    this.renderActiveFacets(parsed);

    if (currentOpenedFilter && event?.target?.closest(".js-filter")) {
      this.renderCounts(currentOpenedFilter, event.target.closest(".js-filter"));
    }

    this.initPriceSliderLater();
  }

  renderActiveFacets(parsed) {
    [".active-facets-mobile", ".active-facets-desktop"].forEach((selector) => {
      const newElement = parsed.querySelector(selector);
      const currentElement = document.querySelector(selector);

      if (newElement && currentElement) {
        currentElement.innerHTML = newElement.innerHTML;
      }
    });

    this.bindActiveFacetButtonEvents();
    this.toggleActiveFacets(false);
  }

  renderCounts(newFilter, currentFilter) {
    [".count-bubble", ".facets__selected"].forEach((selector) => {
      const newElement = newFilter.querySelector(selector);
      const currentElement = currentFilter.querySelector(selector);

      if (newElement && currentElement) {
        currentElement.outerHTML = newElement.outerHTML;
      }
    });
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll(".js-facet-remove").forEach((button) => {
      button.addEventListener("click", this.onActiveFilterClick, { once: true });
    });
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams ? `?${searchParams}` : ""}`
    );
  }

  getSections() {
    return [
      {
        id: this.productGridId,
        section: document.getElementById(this.productGridId).dataset.sectionId
      },
      {
        id: this.filterFormsId,
        section: document.getElementById("main-collection-filters").dataset.id
      }
    ];
  }
}

customElements.define("collection-filtering-form", CollectionFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", this.onRangeChange.bind(this));
    });

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (!minInput || !maxInput) return;

    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", "0");
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range-selector", PriceRange);

class PageType extends HTMLElement {
  constructor() {
    super();

    this.selector = document.querySelector("[data-page-type-selector]");
    if (this.selector) {
      this.selector.addEventListener("change", this.setValue);
    }
  }

  setValue(event) {
    const checkedInputs = event.currentTarget.querySelectorAll("input:checked");
    const value = Array.from(checkedInputs).map((input) => input.value).join(",");
    const input = document.querySelector("#page-type-input");

    if (!input) return;

    input.value = value;

    const inputEvent = new Event("input", { bubbles: true });
    input.closest("form").dispatchEvent(inputEvent);
  }
}

customElements.define("page-type-selector", PageType);